$(function () {
  $(document).on("click", "#copy_address_btn", function () {
    $("#organization_mail_address1").val($("#organization_address1").val());
    $("#organization_mail_address2").val($("#organization_address2").val());
    $("#organization_mail_address_city").val($("#organization_address_city").val());
    $("#organization_mail_address_zip").val($("#organization_address_zip").val());

    const stateValue = $("#organization_address_state").val();
    const mailState = document.querySelector("#organization_mail_address_state");

    if (mailState && mailState.tomselect) {
      mailState.tomselect.setValue(stateValue);
    } else {
      $(mailState).val(stateValue).trigger("change");
    }
  });
});